module.exports = __webpack_public_path__ + "img/73.84787d20.gif";